import {connect} from 'react-redux';

import {makeMapDispatchToProps} from '../../../../../srcCommon/helpers/reselectHelpers';
import {fetchCardGroupsAndFilterPrivateNamespaceAsyncAction} from '../../../../store/data/cardGroups/cardGroupsActions';
import {ModifyCardGroupsDropdown} from './modifyCardGroupDropdown';

/*
 * Redux.
 */

const mapDispatchToProps = makeMapDispatchToProps()(() => ({
  fetchCardGroupsAsync: fetchCardGroupsAndFilterPrivateNamespaceAsyncAction,
}));

export const ModifyCardGroupsDropdownContainer = connect(null, mapDispatchToProps)(ModifyCardGroupsDropdown);
